import {AxiosPromise} from "axios";
import RequestHelper, {ActionAnswer, CommandData} from "../utils/RequestsHelper";

export interface LaunchAnswer {
    id: number
    datetime: string
    sku_count: number
}

export interface HistoryInfo {
    page: number,
    pageCount: number,
    totalPages: number,
    launches: LaunchAnswer[]
}

export default class ExportHistoryApi {
    public static history(pagination: {page:number, pageCount:number}): AxiosPromise<ActionAnswer<HistoryInfo>> {
        return RequestHelper.send("get", "export&action=history", pagination)
    }

    public static launchData(launch_id: number|undefined): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("get", "export&action=launchData", {launch_id: launch_id})
    }


}